export default __webpack_public_path__ + "img/db9f0577f4be6f55e7ae40a5dc1bc1cf.svg";